import { Card, CardContent } from "@/components/ui/card";

import { LoginLogsTable } from "./components/login-logs-table";

export const LoginLogsPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight dark:text-white">Login Logs</h2>
        </div>
      </div>
      <Card>
        <CardContent>
          <LoginLogsTable />
        </CardContent>
      </Card>
    </div>
  );
};
